import React from "react";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
import { borderRadius } from "@mui/system";
import { Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export default function Header({setshowsubTypeFunc, CheckTypeFunc}) {
  return (
    <>
      <Box
        // container

        component="main"
        sx={{
          display: "grid",
          gridAutoColumns: "1fr",
          gap: 1,
          // margin:'20px',
          //   backgroundColor: "#E5E5E5"
        }}
      >
        <Box
          sx={{
            gridRow: "1",
            gridColumn: "span 2",
            display: "flex",
            alignItems: "flex-start",
          }}
        >
          <Box
            sx={{
              width: { lg: "40px", md: "40px", sm: "36px", xs: "32px" },
              height: { lg: "40px", md: "40px", sm: "36px", xs: "32px" },
              cursor:'pointer',
            }}
            onClick={()=> {setshowsubTypeFunc(true); CheckTypeFunc(false);}}
          >
            <img
              src="./images/FrameArrow787.svg"
              alt=""
              width="100%"
              // height="auto"
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box
              sx={{
                width: {
                  lg: "199.91px",
                  md: "199.91px",
                  sm: "190px",
                  xs: "100px",
                },
                height: "32px",
                paddingLeft: "32px",
              }}
            >
              <Link to="/">
                <img src="./images/eatcoast.svg" alt="" width="100%" />
              </Link>
            </Box>
          </Box>
          <Box sx={{}}>
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <Box
                sx={{
                  width: { lg: "60px", md: "60px", sm: "56px", xs: "42px" },
                  height: { lg: "40px", md: "40px", sm: "36px", xs: "32px" },
                  pr: "20px",
                }}
              >
                <img
                  src="./images/Button-icon.svg"
                  alt=""
                  width="100%"
                  // height="auto"
                />
              </Box>

              <Box
                sx={{
                  width: { lg: "40px", md: "40px", sm: "36px", xs: "28px" },
                  height: { lg: "40px", md: "40px", sm: "36px", xs: "32px" },
                  border:"1px solid red"
                }}
              >
                <img
                  src="./images/Drop your Memoji here.svg"
                  alt=""
                  width="100%"
                  // height="auto"
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
